import { createAction } from '@reduxjs/toolkit'

export const fetchWhoAmI = createAction("FETCH_WHOAMI_SAGA")
export const fetchLogout = createAction("FETCH_LOGOUT_SAGA")
